export * from './ngx-select-dropdown.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/ngx-select-dropdown-component/index.ts